import { Component, OnInit, ViewChild } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import jsPDF from 'jspdf';
import { TreeSelect } from 'primeng/treeselect';
import * as _ from 'underscore';
import { forkJoin } from 'rxjs';
import { ClassificationsService } from 'src/app/shared/services/classifications.service';
import { ServicesService } from 'src/app/shared/services/services.service';
import { UsersService } from 'src/app/shared/services/users.service';
import { GlobalCentreNumerisationDTO } from 'src/app/shared/models/iCourrier/centre-numerisation/global-centre-numerisation';
import { ClassificationCodeDto, DropdownService, SourceDto } from 'src/app/shared/interfaces';
import { SourcesService } from 'src/app/shared/services/sources.service';
import { UserDto } from 'src/app/shared/interfaces/users';
import { MeRightMailGlobal } from 'src/app/shared/models/iCourrier/me/right-mail-global';
import { TranslateService } from '@devinforius/i-essentials';
import { MeService } from 'src/app/shared/services/me.service';
import { NumerisationCentersService } from 'src/app/shared/services/numerisation_centers.service';
import {
  manageServicesSetAsTreeSelect,
  manageServicesToBeMerged,
  returnOnlyParentServices,
} from 'src/app/shared/utils/manage-services-for-tree-select.utils';
import { UserContact } from 'src/app/shared/models';
import { ServicesOnlyParent } from 'src/app/shared/models/iCourrier/service';

@Component({
  selector: 'app-separator-page',
  templateUrl: './separator-page.component.html',
  styleUrls: ['./separator-page.component.scss'],
})
export class SeparatorPageComponent implements OnInit {
  @ViewChild('treeSelect') public treeSelect: TreeSelect;

  public form: FormGroup = new FormGroup({
    centreNum: new FormControl(),
    serviceId: new FormControl(),
    sourceId: new FormControl(),
    destinataireContactId: new FormControl(),
    classificationCode: new FormControl(),
  });

  //lié QRCode
  //! Attention si la manière de faire le QRCode change, il faut ABSOLUMENT que le QRCode créé pour FullFromScan soit aussi mis à jour. (attention créé dans le composant, pas le service)
  public qrcodeText = '%SEPARATEUR%';
  public centreNumText = '';
  public serviceText = '';
  public sourceText = '';
  public destinataireText = '';
  public classificationCodesText = '';

  //récup de données
  public numerisations_list: { label: string; value: string; item: GlobalCentreNumerisationDTO }[] = [];
  public language = '';
  public servicesOnlyParents: ServicesOnlyParent[] = [];
  public servicesFusionned: {
    label: string;
    value: number;
    id: number;
    parentId: number;
    name: string;
    key: string;
    selectable: boolean;
    children: [];
  }[] = [];
  public serviceParentChild = [];
  public sources: { label: string; value: number; afficherReferenceRecommande: boolean }[] = [];
  public destinataires: UserContact[] = [];
  public rightToShowAllServices = true;
  public classificationCodes: { label: string; value: number }[] = [];
  //pTreeSelect
  public selectedOption = null;

  public valueCentreNum: string = null;
  public valueService: number = null;
  public valueSource: number = null;
  public valueDestinataire: number = null;
  public valueClassificationCode: number = null;

  public loaded = false;

  constructor(
    private numerisationCentersService: NumerisationCentersService,
    private classificationService: ClassificationsService,
    private servicesService: ServicesService,
    private usersService: UsersService,
    private sourcesService: SourcesService,
    private translater: TranslateService,
    private meService: MeService
  ) {}

  ngOnInit(): void {
    this.loaded = false;
    this.setDatas();
  }

  private setDatas(): void {
    forkJoin({
      listOfNumerisations: this.numerisationCentersService.getGlobalCentreNumerisation(),
      services: this.servicesService.fetchMappedServicesToPrimeNGDropdowns(),
      sources: this.sourcesService.fetchSources(),
      recipients: this.usersService.fetchUsersFromiAdmin({ Active: true }),
      classificationCodes: this.classificationService.fetchClassificationCodes(true),
      meRightMails: this.meService.rightMailGlobal(),
    }).subscribe({
      next: (res: {
        listOfNumerisations: GlobalCentreNumerisationDTO[];
        services: DropdownService[];
        sources: SourceDto[];
        recipients: UserDto[];
        classificationCodes: ClassificationCodeDto[];
        meRightMails: MeRightMailGlobal;
      }) => {
        this.formatNumerisationsList(res.listOfNumerisations);
        this.formatServices(res.services);
        this.formatSources(res.sources);
        this.formatRecipients(res.recipients);
        this.formatClassificationCodes(res.classificationCodes);
        this.getRightToShowAllServices(res.meRightMails);
        this.loaded = true;
      },
    });
  }

  private formatNumerisationsList(listOfNumerisations: GlobalCentreNumerisationDTO[]): void {
    if (listOfNumerisations?.length > 0) {
      listOfNumerisations.forEach((item) => {
        this.numerisations_list.push({ label: item.description, value: item.codeQr, item: item });
      });
    } else {
      this.numerisations_list = [];
    }
  }

  private formatServices(listOfServices: DropdownService[]): void {
    const datasForService = manageServicesSetAsTreeSelect(listOfServices, this.translater);
    this.serviceParentChild = datasForService.servicesForSingleCheck;
    this.servicesOnlyParents = returnOnlyParentServices(listOfServices);
    this.servicesFusionned = manageServicesToBeMerged(listOfServices);
  }

  private formatSources(listOfSources: SourceDto[]): void {
    if (listOfSources?.length > 0) {
      listOfSources.forEach((source) => {
        this.sources.push({
          label: source.description,
          value: source.id,
          afficherReferenceRecommande: source.afficherReferenceRecommande,
        });
      });
      this.sources = _.sortBy(this.sources, 'label');
    } else {
      this.sources = [];
    }
  }

  private formatRecipients(listOfRecipients: UserDto[]): void {
    if (listOfRecipients?.length > 0) {
      listOfRecipients.forEach((user: UserDto) => {
        this.destinataires.push(new UserContact(user));
      });
    } else {
      this.destinataires = [];
    }
  }

  private formatClassificationCodes(listOfClassificationCodes: ClassificationCodeDto[]): void {
    if (listOfClassificationCodes?.length > 0) {
      listOfClassificationCodes.forEach((classement) => {
        this.classificationCodes.push({
          label: classement.code + (classement.description ? ' (' + classement.description + ')' : ''),
          value: classement.id,
        });
      });
      this.classificationCodes = _.sortBy(this.classificationCodes, 'label');
    } else {
      this.classificationCodes = [];
    }
  }

  private getRightToShowAllServices(meRightMails: MeRightMailGlobal): void {
    this.rightToShowAllServices = !meRightMails.iScan.limitFirstLevelService;
  }

  updateFieldQRcodeCentreNum(value): void {
    this.valueCentreNum = value;
    if (value) {
      this.centreNumText = '<CENTERNUM>' + value + '</CENTERNUM>';
    } else {
      this.centreNumText = '';
    }
    //! Attention si la manière de faire le QRCode change, il faut ABSOLUMENT que le QRCode créé pour FullFromScan soit aussi mis à jour. (attention créé dans le composant, pas le service)
    this.qrcodeText = '%SEPARATEUR%' + this.centreNumText + this.serviceText + this.sourceText + this.destinataireText + this.classificationCodesText;
  }

  openQRCODE(): void {
    const qrcode = document.getElementsByClassName('qrcode');
    if (qrcode.length > 0) {
      const base64 = qrcode[0].children.length > 0 ? qrcode[0].children[0]['src'] : null;
      const doc = new jsPDF({ orientation: 'portrait' });
      doc.addImage(base64, 'png', 5, 5, 40, 40);
      doc.setFontSize(12);

      const centreNum =
        'Centre de numérisation : ' + (this.valueCentreNum ? this.numerisations_list.find((x) => x.value === this.valueCentreNum)?.label : '/');
      doc.text(centreNum, 45, 13);
      const service = 'Service : ' + (this.valueService ? this.servicesFusionned.find((x) => x.value === this.valueService)?.label : '/');
      doc.text(service, 45, 23);
      const source = 'Source : ' + (this.valueSource ? this.sources.find((x) => x.value === this.valueSource)?.label : '/');
      doc.text(source, 45, 33);
      const destinataire =
        'Destinataire : ' + (this.valueDestinataire ? this.destinataires.find((x) => x.userId === this.valueDestinataire)?.name : '/');
      doc.text(destinataire, 45, 43);
      const classificationCode =
        'Code de classement : ' +
        (this.valueClassificationCode ? this.classificationCodes.find((x) => x.value === this.valueClassificationCode)?.label : '/');
      doc.text(classificationCode, 45, 53);

      doc.save('page_separator');
    }
  }

  select(event): void {
    if (event.node && event.node.value) {
      this.valueService = event.node.value;
      if (this.selectedOption?.value !== event.node.value) {
        this.selectedOption = _.first(this.servicesFusionned.filter((x) => x.value === event.node.value));
        const labelTreeHtml = document.querySelectorAll('.treeSelect .p-treeselect-label');
        labelTreeHtml[0].innerHTML = this.selectedOption.label;
        this.form.patchValue({
          serviceId: event.node.value,
        });
        this.serviceText = '<SVCID>' + event.node.value + '</SVCID>';
      } else {
        this.selectedOption = null;
        const labelTreeHtml = document.querySelectorAll('.treeSelect .p-treeselect-label');
        labelTreeHtml[0].innerHTML = this.translater.translate('pleaseSelectAService');
        this.treeSelect.value = [];
        this.form.patchValue({
          serviceId: null,
        });
        this.serviceText = '';
        this.valueService = null;
      }
    } else {
      this.valueService = null;
    }
    //! Attention si la manière de faire le QRCode change, il faut ABSOLUMENT que le QRCode créé pour FullFromScan soit aussi mis à jour. (attention créé dans le composant, pas le service)
    this.qrcodeText = '%SEPARATEUR%' + this.centreNumText + this.serviceText + this.sourceText + this.destinataireText + this.classificationCodesText;
  }

  updateFieldQRcodeSource(value): void {
    this.valueSource = value;
    if (value) {
      this.sourceText = '<SRCID>' + value + '</SRCID>';
    } else {
      this.sourceText = '';
    }
    //! Attention si la manière de faire le QRCode change, il faut ABSOLUMENT que le QRCode créé pour FullFromScan soit aussi mis à jour. (attention créé dans le composant, pas le service)
    this.qrcodeText = '%SEPARATEUR%' + this.centreNumText + this.serviceText + this.sourceText + this.destinataireText + this.classificationCodesText;
  }

  updateFieldQRcodeRecipient(value): void {
    this.valueDestinataire = value;
    if (value) {
      const destinataireContactId = this.destinataires.find((x) => {
        if (x.id === value) {
          return x;
        }
      });
      this.destinataireText = '<DESTCNTID>' + destinataireContactId.contactForUser.contactId + '</DESTCNTID>';
    } else {
      this.destinataireText = '';
    }
    //! Attention si la manière de faire le QRCode change, il faut ABSOLUMENT que le QRCode créé pour FullFromScan soit aussi mis à jour. (attention créé dans le composant, pas le service)
    this.qrcodeText = '%SEPARATEUR%' + this.centreNumText + this.serviceText + this.sourceText + this.destinataireText + this.classificationCodesText;
  }

  updateFieldQRcodeClassificationCode(value): void {
    this.valueClassificationCode = value;
    if (value) {
      this.classificationCodesText = '<CODECLASSID>' + value + '</CODECLASSID>';
    } else {
      this.classificationCodesText = '';
    }
    //! Attention si la manière de faire le QRCode change, il faut ABSOLUMENT que le QRCode créé pour FullFromScan soit aussi mis à jour. (attention créé dans le composant, pas le service)
    this.qrcodeText = '%SEPARATEUR%' + this.centreNumText + this.serviceText + this.sourceText + this.destinataireText + this.classificationCodesText;
  }
}
